import { initialize as initializeStringStore, PrefetchedStrings } from 'owa-strings';
import { resolve as urlResolve } from 'url';

export var userLocale: string;

export var userSmtpAddress: string;

export var stringsDir: string;

export var prefetchedStrings: PrefetchedStrings;

export var needInitialization: boolean;

export function initializeStrings(): void {
    let locale = 'en';
    let dir = '/';

    if (userLocale) {
        locale = userLocale;
    }

    if (stringsDir) {
        dir = stringsDir;
    }

    initializeStringStore(urlResolve(dir, 'resources/locale/'), locale, prefetchedStrings);
}

export function registerStrings(prefetchedStringsValue: PrefetchedStrings) {
    prefetchedStrings = prefetchedStringsValue;
}

export function initializeStringsDir(stringsDirValue: string) {
    stringsDir = stringsDirValue;
}

export function initializeUserSettings(userSmtpAddressValue: string, userLocaleValue: string) {
    userLocale = userLocaleValue;
    userSmtpAddress = userSmtpAddressValue;
}

export function getUserSmtp() {
    return userSmtpAddress;
}
